__turbopack_context__.v({
  "ai-lg-baseline": "_2i9xqa_ai-lg-baseline",
  "ai-lg-center": "_2i9xqa_ai-lg-center",
  "ai-lg-end": "_2i9xqa_ai-lg-end",
  "ai-lg-flex-end": "_2i9xqa_ai-lg-flex-end",
  "ai-lg-flex-start": "_2i9xqa_ai-lg-flex-start",
  "ai-lg-normal": "_2i9xqa_ai-lg-normal",
  "ai-lg-self-end": "_2i9xqa_ai-lg-self-end",
  "ai-lg-self-start": "_2i9xqa_ai-lg-self-start",
  "ai-lg-start": "_2i9xqa_ai-lg-start",
  "ai-lg-stretch": "_2i9xqa_ai-lg-stretch",
  "ai-md-baseline": "_2i9xqa_ai-md-baseline",
  "ai-md-center": "_2i9xqa_ai-md-center",
  "ai-md-end": "_2i9xqa_ai-md-end",
  "ai-md-flex-end": "_2i9xqa_ai-md-flex-end",
  "ai-md-flex-start": "_2i9xqa_ai-md-flex-start",
  "ai-md-normal": "_2i9xqa_ai-md-normal",
  "ai-md-self-end": "_2i9xqa_ai-md-self-end",
  "ai-md-self-start": "_2i9xqa_ai-md-self-start",
  "ai-md-start": "_2i9xqa_ai-md-start",
  "ai-md-stretch": "_2i9xqa_ai-md-stretch",
  "ai-sm-baseline": "_2i9xqa_ai-sm-baseline",
  "ai-sm-center": "_2i9xqa_ai-sm-center",
  "ai-sm-end": "_2i9xqa_ai-sm-end",
  "ai-sm-flex-end": "_2i9xqa_ai-sm-flex-end",
  "ai-sm-flex-start": "_2i9xqa_ai-sm-flex-start",
  "ai-sm-normal": "_2i9xqa_ai-sm-normal",
  "ai-sm-self-end": "_2i9xqa_ai-sm-self-end",
  "ai-sm-self-start": "_2i9xqa_ai-sm-self-start",
  "ai-sm-start": "_2i9xqa_ai-sm-start",
  "ai-sm-stretch": "_2i9xqa_ai-sm-stretch",
  "ai-xl-baseline": "_2i9xqa_ai-xl-baseline",
  "ai-xl-center": "_2i9xqa_ai-xl-center",
  "ai-xl-end": "_2i9xqa_ai-xl-end",
  "ai-xl-flex-end": "_2i9xqa_ai-xl-flex-end",
  "ai-xl-flex-start": "_2i9xqa_ai-xl-flex-start",
  "ai-xl-normal": "_2i9xqa_ai-xl-normal",
  "ai-xl-self-end": "_2i9xqa_ai-xl-self-end",
  "ai-xl-self-start": "_2i9xqa_ai-xl-self-start",
  "ai-xl-start": "_2i9xqa_ai-xl-start",
  "ai-xl-stretch": "_2i9xqa_ai-xl-stretch",
  "fd-lg-column": "_2i9xqa_fd-lg-column",
  "fd-lg-column-reverse": "_2i9xqa_fd-lg-column-reverse",
  "fd-lg-row": "_2i9xqa_fd-lg-row",
  "fd-lg-row-reverse": "_2i9xqa_fd-lg-row-reverse",
  "fd-md-column": "_2i9xqa_fd-md-column",
  "fd-md-column-reverse": "_2i9xqa_fd-md-column-reverse",
  "fd-md-row": "_2i9xqa_fd-md-row",
  "fd-md-row-reverse": "_2i9xqa_fd-md-row-reverse",
  "fd-sm-column": "_2i9xqa_fd-sm-column",
  "fd-sm-column-reverse": "_2i9xqa_fd-sm-column-reverse",
  "fd-sm-row": "_2i9xqa_fd-sm-row",
  "fd-sm-row-reverse": "_2i9xqa_fd-sm-row-reverse",
  "fd-xl-column": "_2i9xqa_fd-xl-column",
  "fd-xl-column-reverse": "_2i9xqa_fd-xl-column-reverse",
  "fd-xl-row": "_2i9xqa_fd-xl-row",
  "fd-xl-row-reverse": "_2i9xqa_fd-xl-row-reverse",
  "flexItems": "_2i9xqa_flexItems",
  "fw-lg-nowrap": "_2i9xqa_fw-lg-nowrap",
  "fw-lg-wrap": "_2i9xqa_fw-lg-wrap",
  "fw-lg-wrap-reverse": "_2i9xqa_fw-lg-wrap-reverse",
  "fw-md-nowrap": "_2i9xqa_fw-md-nowrap",
  "fw-md-wrap": "_2i9xqa_fw-md-wrap",
  "fw-md-wrap-reverse": "_2i9xqa_fw-md-wrap-reverse",
  "fw-sm-nowrap": "_2i9xqa_fw-sm-nowrap",
  "fw-sm-wrap": "_2i9xqa_fw-sm-wrap",
  "fw-sm-wrap-reverse": "_2i9xqa_fw-sm-wrap-reverse",
  "fw-xl-nowrap": "_2i9xqa_fw-xl-nowrap",
  "fw-xl-wrap": "_2i9xqa_fw-xl-wrap",
  "fw-xl-wrap-reverse": "_2i9xqa_fw-xl-wrap-reverse",
  "gap-lg-1": "_2i9xqa_gap-lg-1",
  "gap-lg-10": "_2i9xqa_gap-lg-10",
  "gap-lg-11": "_2i9xqa_gap-lg-11",
  "gap-lg-12": "_2i9xqa_gap-lg-12",
  "gap-lg-13": "_2i9xqa_gap-lg-13",
  "gap-lg-14": "_2i9xqa_gap-lg-14",
  "gap-lg-2": "_2i9xqa_gap-lg-2",
  "gap-lg-3": "_2i9xqa_gap-lg-3",
  "gap-lg-4": "_2i9xqa_gap-lg-4",
  "gap-lg-5": "_2i9xqa_gap-lg-5",
  "gap-lg-6": "_2i9xqa_gap-lg-6",
  "gap-lg-7": "_2i9xqa_gap-lg-7",
  "gap-lg-8": "_2i9xqa_gap-lg-8",
  "gap-lg-9": "_2i9xqa_gap-lg-9",
  "gap-md-1": "_2i9xqa_gap-md-1",
  "gap-md-10": "_2i9xqa_gap-md-10",
  "gap-md-11": "_2i9xqa_gap-md-11",
  "gap-md-12": "_2i9xqa_gap-md-12",
  "gap-md-13": "_2i9xqa_gap-md-13",
  "gap-md-14": "_2i9xqa_gap-md-14",
  "gap-md-2": "_2i9xqa_gap-md-2",
  "gap-md-3": "_2i9xqa_gap-md-3",
  "gap-md-4": "_2i9xqa_gap-md-4",
  "gap-md-5": "_2i9xqa_gap-md-5",
  "gap-md-6": "_2i9xqa_gap-md-6",
  "gap-md-7": "_2i9xqa_gap-md-7",
  "gap-md-8": "_2i9xqa_gap-md-8",
  "gap-md-9": "_2i9xqa_gap-md-9",
  "gap-sm-1": "_2i9xqa_gap-sm-1",
  "gap-sm-10": "_2i9xqa_gap-sm-10",
  "gap-sm-11": "_2i9xqa_gap-sm-11",
  "gap-sm-12": "_2i9xqa_gap-sm-12",
  "gap-sm-13": "_2i9xqa_gap-sm-13",
  "gap-sm-14": "_2i9xqa_gap-sm-14",
  "gap-sm-2": "_2i9xqa_gap-sm-2",
  "gap-sm-3": "_2i9xqa_gap-sm-3",
  "gap-sm-4": "_2i9xqa_gap-sm-4",
  "gap-sm-5": "_2i9xqa_gap-sm-5",
  "gap-sm-6": "_2i9xqa_gap-sm-6",
  "gap-sm-7": "_2i9xqa_gap-sm-7",
  "gap-sm-8": "_2i9xqa_gap-sm-8",
  "gap-sm-9": "_2i9xqa_gap-sm-9",
  "gap-xl-1": "_2i9xqa_gap-xl-1",
  "gap-xl-10": "_2i9xqa_gap-xl-10",
  "gap-xl-11": "_2i9xqa_gap-xl-11",
  "gap-xl-12": "_2i9xqa_gap-xl-12",
  "gap-xl-13": "_2i9xqa_gap-xl-13",
  "gap-xl-14": "_2i9xqa_gap-xl-14",
  "gap-xl-2": "_2i9xqa_gap-xl-2",
  "gap-xl-3": "_2i9xqa_gap-xl-3",
  "gap-xl-4": "_2i9xqa_gap-xl-4",
  "gap-xl-5": "_2i9xqa_gap-xl-5",
  "gap-xl-6": "_2i9xqa_gap-xl-6",
  "gap-xl-7": "_2i9xqa_gap-xl-7",
  "gap-xl-8": "_2i9xqa_gap-xl-8",
  "gap-xl-9": "_2i9xqa_gap-xl-9",
  "jc-lg-center": "_2i9xqa_jc-lg-center",
  "jc-lg-end": "_2i9xqa_jc-lg-end",
  "jc-lg-flex-end": "_2i9xqa_jc-lg-flex-end",
  "jc-lg-flex-start": "_2i9xqa_jc-lg-flex-start",
  "jc-lg-left": "_2i9xqa_jc-lg-left",
  "jc-lg-normal": "_2i9xqa_jc-lg-normal",
  "jc-lg-right": "_2i9xqa_jc-lg-right",
  "jc-lg-space-around": "_2i9xqa_jc-lg-space-around",
  "jc-lg-space-between": "_2i9xqa_jc-lg-space-between",
  "jc-lg-space-evenly": "_2i9xqa_jc-lg-space-evenly",
  "jc-lg-start": "_2i9xqa_jc-lg-start",
  "jc-lg-stretch": "_2i9xqa_jc-lg-stretch",
  "jc-md-center": "_2i9xqa_jc-md-center",
  "jc-md-end": "_2i9xqa_jc-md-end",
  "jc-md-flex-end": "_2i9xqa_jc-md-flex-end",
  "jc-md-flex-start": "_2i9xqa_jc-md-flex-start",
  "jc-md-left": "_2i9xqa_jc-md-left",
  "jc-md-normal": "_2i9xqa_jc-md-normal",
  "jc-md-right": "_2i9xqa_jc-md-right",
  "jc-md-space-around": "_2i9xqa_jc-md-space-around",
  "jc-md-space-between": "_2i9xqa_jc-md-space-between",
  "jc-md-space-evenly": "_2i9xqa_jc-md-space-evenly",
  "jc-md-start": "_2i9xqa_jc-md-start",
  "jc-md-stretch": "_2i9xqa_jc-md-stretch",
  "jc-sm-center": "_2i9xqa_jc-sm-center",
  "jc-sm-end": "_2i9xqa_jc-sm-end",
  "jc-sm-flex-end": "_2i9xqa_jc-sm-flex-end",
  "jc-sm-flex-start": "_2i9xqa_jc-sm-flex-start",
  "jc-sm-left": "_2i9xqa_jc-sm-left",
  "jc-sm-normal": "_2i9xqa_jc-sm-normal",
  "jc-sm-right": "_2i9xqa_jc-sm-right",
  "jc-sm-space-around": "_2i9xqa_jc-sm-space-around",
  "jc-sm-space-between": "_2i9xqa_jc-sm-space-between",
  "jc-sm-space-evenly": "_2i9xqa_jc-sm-space-evenly",
  "jc-sm-start": "_2i9xqa_jc-sm-start",
  "jc-sm-stretch": "_2i9xqa_jc-sm-stretch",
  "jc-xl-center": "_2i9xqa_jc-xl-center",
  "jc-xl-end": "_2i9xqa_jc-xl-end",
  "jc-xl-flex-end": "_2i9xqa_jc-xl-flex-end",
  "jc-xl-flex-start": "_2i9xqa_jc-xl-flex-start",
  "jc-xl-left": "_2i9xqa_jc-xl-left",
  "jc-xl-normal": "_2i9xqa_jc-xl-normal",
  "jc-xl-right": "_2i9xqa_jc-xl-right",
  "jc-xl-space-around": "_2i9xqa_jc-xl-space-around",
  "jc-xl-space-between": "_2i9xqa_jc-xl-space-between",
  "jc-xl-space-evenly": "_2i9xqa_jc-xl-space-evenly",
  "jc-xl-start": "_2i9xqa_jc-xl-start",
  "jc-xl-stretch": "_2i9xqa_jc-xl-stretch",
});
